(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
     let productCarousel = document.querySelector(".js-product-carousel");
     let productColumn   = productCarousel.dataset.column;
     let productLoop     = productCarousel.dataset.loop;

     if(Number(productLoop) < Number(productColumn)) {
          var loop = false;
     } else {
          var loop = true;
     }


  let init = false;
  let swiper_products;

  function swiperProduct() {
      if (window.innerWidth >= 575) {
      if (!init) {
        init = true;
          let productSwiper = new Swiper(".js-product-carousel", {
              slidesPerView: 1,
              // autoHeight: true,
              spaceBetween: 10,
              loop: loop,
              freeMode: true,
              preventClicks :true,
              a11y: false,
              navigation: {
                  nextEl: ".swiper-button-next.js-button-next",
                  prevEl: ".swiper-button-prev.js-button-prev",
              },

              breakpoints: {
                  575: {
                      spaceBetween: 10,
                      slidesPerView: 1,
                      allowTouchMove: true,

                  },
                  768: {
                      spaceBetween: 20,
                      slidesPerView: 2,
                      allowTouchMove: false,
                  },
                  1200: {
                      spaceBetween: 20,
                      slidesPerView: 3,
                      allowTouchMove: false,
                  },

                  1360: {
                      spaceBetween: 30,
                      slidesPerView: 3,
                      allowTouchMove: false,
                  }

              }

          });
      }
    } else if (init) {
      swiper_products.destroy();
      init = false;
    }
  }
  swiperProduct();
  window.addEventListener("resize", swiperProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  
  /// ### FAQ Script ###
let animationInProgress = false;

// slideUp function
function slideUp(target, parent, duration = 300) {

    if(target) {
        animationInProgress = true;
        target.style.height = target.offsetHeight + 'px';
        parent.style.pointerEvents = "none";

        window.setTimeout( () => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            target.style.height = 0;
        }, 100);
        window.setTimeout( () => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;
        }, duration + 100);
    }

}
// slideDown function
function slideDown(target, parent, duration = 300){
    if(target) {
        animationInProgress = true;
        target.style.removeProperty('display');
        parent.style.pointerevents = "none";
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;

        window.setTimeout( () => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.height = height + 'px';
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
        }, 100);
        window.setTimeout( () => {
            target.style.removeProperty('height');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;
        }, duration + 100);
    }
}

// slideToggle function
function slideToggle(target, parent, duration = 300) {

    if(target && !animationInProgress) {
        if (window.getComputedStyle(target).display === 'none') {
            return slideDown(target, parent, duration);
        } else {
            return slideUp(target, parent, duration);
        }
    }

}

//FAQ Script to target and make active on click
let faq = document.querySelectorAll('.js-faq-trigger');

faq.forEach( function(item) {
    item.addEventListener('click', toggleItem);
});

function toggleItem(e) {
    e.preventDefault();   

    let item = e.target.closest('.faq');
    item.classList.toggle('active');
    slideToggle(item.querySelector('.js-faq-content'), item);

    for (let sibling of item.parentNode.children) {
        if (sibling !== item) {
            sibling.classList.remove('active');
            slideUp(sibling.querySelector('.js-faq-content'), sibling);
        }
    }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
     
 
    const swiper = new Swiper('.js-testimonial-carousel', {
        speed: 400,  
        spaceBetween: 20,
        loop: true,
        slidesPerView: 1,
        // centeredSlides: true,
        allowTouchMove: true,
        autoHeight: true,
        speed: 900,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        breakpoints: {
            576: {
                spaceBetween: 10,
                slidesPerView: 1,
                allowTouchMove: true,
                autoHeight: true,
            },
            768: {
                spaceBetween: 10,
                slidesPerView: 2,
                allowTouchMove: false,
                // autoHeight: false,
            },
            1400: {
                loop: true,
                spaceBetween: 30,
                slidesPerView: 3,
                allowTouchMove: false,
                autoHeight: true,
            },
        }
    });


  } catch(e) { console.error(e); }
})();
})();
